import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';

export class SetParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] SetParticipantPartialGrades';

    constructor(public payload: PartialGrade[]) {}
}

export class UnsetParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] UnsetParticipantPartialGrades';
}

export class FetchParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] FetchParticipantPartialGrades';

    constructor(public payload: string) {}
}

export class FetchParticipantPartialGradesSuccess {
    static readonly type = '[ParticipantPartialGrades] FetchParticipantPartialGradesSuccess';
}

export class FetchParticipantPartialGradesFailure {
    static readonly type = '[ParticipantPartialGrades] FetchParticipantPartialGradesFailure';
}

export class ToggleSelectedParticipantPartialGrade {
    static readonly type = '[ParticipantPartialGrades] ToggleSelectedParticipantPartialGrade';

    constructor(public payload: string) {}
}

export class SelectFilteredParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] SelectFilteredParticipantPartialGrades';
}

export class DeselectSelectedParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] DeselectSelectedParticipantPartialGrades';
}

export class SearchParticipantPartialGrades {
    static readonly type = '[ParticipantPartialGrades] SearchParticipantPartialGrades';

    constructor(public payload: string) {}
}
